import React, { useEffect } from 'react';
import useResponsiveStore from '../stores/responsiveStore';

const ResponsiveListener = () => {
  const { updateResponsiveFlags } = useResponsiveStore();

  useEffect(() => {
    const handleResize = () => {
      updateResponsiveFlags(window.innerWidth);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [updateResponsiveFlags]);

  return null;
};

export default ResponsiveListener;
